import numeral from 'numeral'

/*
Convert cents to dollars and format as currency without the ".00".
If showCents is true, OR dollars are not an integer amount, include cents.
e.g. 269500 => $2,695
e.g. 50 => $0.50
*/
const centsToDollars = (cents, showCents = false) => {
  const formatString = showCents || cents % 100 !== 0 ? '$0,0[.]00' : '$0,0'
  return numeral(cents / 100).format(formatString)
}

export { centsToDollars }
